<template>
  <div class="god">
    <div class="q-pa-sm">
      <el-dialog :title="mytaskbyid.name" :visible.sync="editFormVisible" class="edit-dialog"
        :close-on-click-modal="false" :close-on-press-escape="false">
        <!--      头部信息      -->
        <div v-if="activeName == 'first'" class="dialog-data1">
          <div class="dialog-data2">
            <div class="font-icon beijinyuan">
              <i class="el-icon-time"></i>
            </div>
            <!--                  <div><span>{{mytaskbyid.status == 1 ? '未开始' : mytaskbyid.status == 2 ? '进行中' : '已完成'
            }}</span><br/><span>当前状态</span></div>-->
            <div>
              <div style="display: flex;justify-content: start;position: relative;height: 30px">
                <template>
                  <el-select class="minFont1 heihei" style="position: absolute;left: 0;top:0;z-index: 20;cursor: pointer"
                    v-model="mytaskbyid.status" @change="(value) => {
                        updateStatus(value, mytaskbyid.id);
                      }
                      ">
                    <el-option v-for="items in typeList" :key="items.id" :label="items.name" :value="items.id">
                    </el-option>
                  </el-select>
                </template>
                <i class="iconfont el-icon-sanjiaoxing-copy"
                  style="display: block;height: 30px;line-height: 30px;font-size: 16px;cursor: pointer;color: #2b52e9;position: absolute;left: 55px;top: 0"></i>
              </div>
              <span class="minFont">当前状态</span>
            </div>
          </div>
          <div class="dialog-data2">
            <div class="font-icon">
              <!-- <el-image
                :src="$url.img+avatar"
                ></el-image> -->
              <el-image :src="'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'"
                style="height: 40px; width: 40px; border-radius: 50%"
                v-if="avatar.avatar1 == '' || avatar.avatar1 == undefined"></el-image>
              <el-avatar :src="avatar.avatar1.substr(0, 4) == 'http' ? avatar.avatar1 : $url.img + avatar.avatar1"
                @error="errorHandler"
                :key="avatar.avatar1.substr(0, 4) == 'http' ? avatar.avatar1 : $url.img + avatar.avatar1" v-else>
              </el-avatar>
            </div>
            <div>
              <span class="minFont1">{{ mytaskbyid.charger_name }}</span><br /><span class="minFont">负责人</span>
            </div>
          </div>
          <div class="dialog-data2">
            <div class="font-icon beijinyuan">
              <i class="el-icon-date"></i>
            </div>
            <div>
              <span class="minFont1">{{ mytaskbyid.start_time }}</span><br /><span class="minFont">开始时间</span>
            </div>
          </div>
          <div class="dialog-data2">
            <div class="font-icon beijinyuan">
              <i class="el-icon-folder-checked"></i>
            </div>
            <div>
              <!--                    <span class="minFont1">{{}}</span>-->
              <el-date-picker class="minFont1" @change="updateTime(mytaskbyid.id, mytaskbyid.project_id)"
                v-model="mytaskbyid.end_time" value-format="yyyy-MM-dd" type="date" :picker-options="pickerOptions"
                placeholder="选择日期">
              </el-date-picker>
              <br /><span class="minFont">结束时间</span>
            </div>
          </div>
        </div>
        <el-divider v-if="activeName == 'first'"></el-divider>
        <!--     分割线下的信息       -->
        <el-form v-if="activeName == 'first'" :inline="true" class="demo-form-inline form-text">
          <el-form-item label="项目名称">
            <el-input disabled v-model="mytaskbyid.name"></el-input>
          </el-form-item>
          <el-form-item label="优先等级">
            <el-select v-model="priority" @change="updateTa(mytaskbyid.id, mytaskbyid.project_id)">
              <el-option v-for="item in xuanze" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <div style="height: 1px; width: 10px"></div>
          <el-form-item label="参与人" class="lefta">
            <span v-for="(t, index) in mytaskbyidTask" :key="index">
              <el-image :src="'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'" style="
                        height: 40px;
                        width: 40px;
                        border-radius: 50%;
                        margin-left: 5px;
                      " v-if="t.user_avatar == '' || t.user_avatar == undefined"></el-image>
              <el-avatar :src="t.user_avatar.substr(0, 4) == 'http' ? t.user_avatar : $url.img + t.user_avatar"
                :key="t.user_avatar.substr(0, 4) == 'http' ? t.user_avatar : $url.img + t.user_avatar" v-else>
              </el-avatar>&nbsp;
            </span>
          </el-form-item>
          <el-form-item label="备注" class="lastitem">
            <el-input v-model="mytaskbyid.remark" :rows="2" type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <div style="width: 100%;height: 100%" v-else>
          <el-form :inline="true" class="demo-form-inline form-text">
            <el-form-item label="备注" class="lastitem wcrw">
              <el-input v-model="mytaskbyid.remark" :rows="4" type="textarea"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn-submit" type="primary" @click="updateMark(mytaskbyid.id, mytaskbyid.project_id)">
            确认修改
          </el-button>
        </div>
      </el-dialog>

      <template>
        <el-tabs v-model="activeName" @tab-click="handkeClick">
          <el-tab-pane label="活动任务" name="first" class="aaaa">

            <!-- 绑定二维码 暂时屏蔽-->
            <el-dialog :title="title1" class="eldiang" :visible.sync="editFormVisible1" :close-on-click-modal="false"
              :close-on-press-escape="false">
              <el-image :src="src">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
              <div style="margin-bottom:10px;color:#333333;font-size:14px;font-weight: 600;">
                请先关注禾略公众号，再扫码绑定，以便收到系统项目和任务变更通知
              </div>
              <div style="color:#2b51e8;font-size:14px;font-weight: 600;cursor: pointer;" @click="openimg"
                v-if="gongzhong == false">点击关注禾略公众号
              </div>
              <div style="color:#2b51e8;font-size:14px;font-weight: 600;cursor: pointer;" @click="openimg" v-else>
                点击关闭禾略公众号
              </div>
              <el-image style="width: 62%;" :src="require('../../assets/img/gongzonghao.jpg')" v-show="gongzhong == true">
              </el-image>
            </el-dialog>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="col-title">
                  我收到的任务 <span>（{{ mytask_count }}）</span>
                </div>
                <div class="grid-content bg-purple">
                  <!--     每个小卡片信息           -->
                  <div :class="thStatus == 2 && item.status == 1
                      ? 'min-box-active'
                      : thStatus == 2 && item.status == 2
                        ? 'min-box-start'
                        : 'min-box'
                    " v-for="(item, index) in mytask" :style="{ backgroundColor: getColor(item) }"
                    @click="open(item.id)" :key="index">
                    <!--     状态+头像             -->
                    <div class="min-header">
                      <div style="display: flex;justify-content: start;position: relative">
                        <template>
                          <el-select class="wangle" v-model="item.status" @change="(value) => {
                              updateStatus(value, item.id);
                            }
                            ">
                            <el-option v-for="items in typeList" :key="items.id" :label="items.name" :value="items.id">

                            </el-option>
                          </el-select>
                        </template>
                        <!--                        :style="{ color: getColor(item) }"-->
                        <i class="iconfont el-icon-sanjiaoxing-copy"
                          style="display: block;height: 30px;line-height: 30px;font-size: 16px;cursor: pointer;position: absolute;top: 0;left: 55px"
                          @click.stop></i>
                      </div>
                      <div class="min-img">
                        <el-image :src="'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'"
                          style="height: 40px; width: 40px; border-radius: 50%"
                          v-if="item.charger_avatar == '' || item.charger_avatar == undefined"></el-image>

                        <el-avatar
                          :src="item.charger_avatar.substr(0, 4) == 'http' ? item.charger_avatar : $url.img + item.charger_avatar"
                          :key="item.charger_avatar.substr(0, 4) == 'http' ? item.charger_avatar : $url.img + item.charger_avatar"
                          v-else>
                        </el-avatar>
                      </div>
                    </div>
                    <!--     任务名称             -->
                    <div class="min-name">{{ item.name }}</div>
                    <!--         任务信息         -->
                    <div class="min-data">
                      <span><i class="el-icon-time"></i> 截止时间：{{
                        item.end_time
                      }}</span><span :title="item.project_name" style="
                          text-align: right;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          word-break: keep-all;
                        "><i class="el-icon-document"></i> 所属项目：{{
                          item.project_name
                        }}</span>
                    </div>
                  </div>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="col-title">
                  今日要做 <span>（{{ tasking_count }}）</span>
                </div>
                <div class="grid-content bg-purple">
                  <!--     每个小卡片信息           -->
                  <div :class="thStatus == 2 && item.status == 1
                      ? 'min-box-active'
                      : thStatus == 2 && item.status == 2
                        ? 'min-box-start'
                        : 'min-box'
                    " v-for="(item, index) in tasking" :style="{ backgroundColor: getColor(item) }"
                    @click="open(item.id)" :key="index">
                    <!--     状态+头像             -->
                    <div class="min-header">
                      <div style="display: flex;justify-content: start;position:relative;">
                        <template>
                          <el-select class="wangle" v-model="item.status" @change="(value) => {
                              updateStatus(value, item.id);
                            }
                            ">
                            <el-option v-for="items in typeList" :key="items.id" :label="items.name" :value="items.id">
                            </el-option>
                          </el-select>
                        </template>
                        <i class="iconfont el-icon-sanjiaoxing-copy"
                          style="display: block;height: 30px;line-height: 30px;font-size: 16px;cursor: pointer;position:absolute;top: 0;left: 55px"
                          @click=""></i>
                      </div>
                      <div class="min-img">


                        <el-avatar
                          :src="item.charger_avatar.substr(0, 4) == 'http' ? item.charger_avatar : $url.img + item.charger_avatar"
                          :key="item.charger_avatar.substr(0, 4) == 'http' ? item.charger_avatar : $url.img + item.charger_avatar"
                          v-if="item.charger_avatar != '' ||
                            item.charger_avatar != undefined
                            "></el-avatar>
                        <el-image :src="'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'"
                          style="height: 40px; width: 40px; border-radius: 50%" v-else></el-image>
                      </div>
                    </div>
                    <!--     任务名称             -->
                    <div class="min-name">{{ item.name }}</div>
                    <!--         任务信息         -->
                    <div class="min-data">
                      <span><i class="el-icon-time"></i> 截止时间：{{
                        item.end_time
                      }}</span><span :title="item.project_name" style="
                          text-align: right;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          word-break: keep-all;
                        "><i class="el-icon-document"></i> 所属项目：{{
                          item.project_name
                        }}</span>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="col-title">笔记</div>
                <div class="grid-content bg-purple">
                  <!--     每个小卡片信息           -->
                  <div class="min-box-book" v-for="(item, index) in notes" :key="index">
                    <!--         任务信息         -->
                    <div class="min-data">
                      <span><i class="el-icon-time"></i> 开始时间：{{
                        item.created_at.slice(0, 10)
                      }}</span>
                      <!--               删除笔记       -->
                      <i class="el-icon-delete" style="float: right; cursor: pointer; color: #708aeb"
                        @click="delnote(item.id)"></i>
                    </div>
                    <!--     内容           -->
                    <div class="min-name">{{ item.content }}</div>
                  </div>

                  <!--    新增笔记            -->
                  <div class="min-box-book min-form">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item>
                        <el-input v-model="addnote1" placeholder="笔记内容"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="addnote">确认
                        </el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="完成任务" name="second">
            <el-table :header-cell-style="{
              background: '#f5f5f5',
              color: '#666666',
              fontSize: '16px',
              fontWeight: 400,
            }" :data="myFinishTask">
              <el-table-column label="编号" align="center" prop="id"></el-table-column>
              <el-table-column label="状态" prop="status">
                <template slot-scope="scope">
                  <span style="color: #5ec16c">
                    {{
                      scope.row.status == 1
                      ? "未开始"
                      : scope.row.status == 2
                        ? "进行中"
                        : "已完成"
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="任务名称" prop="name"></el-table-column>
              <el-table-column label="负责人" prop="charger_name"></el-table-column>
              <el-table-column label="开始时间" prop="start_time"></el-table-column>
              <el-table-column label="结束时间" prop="end_time"></el-table-column>
              <el-table-column label="实际完成时间" prop="finish_time"></el-table-column>
              <el-table-column label="所属项目" prop="project_name"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span class="nav" @click="open(scope.row.id)" style="margin-right: 4px;cursor: pointer;color: #2b52e9">
                    编辑备注</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-if="total > 0" :currentPage="currentPage" :total="total" :limit="limit"
              @handleCurrentChange="handleCurrentChange"></Pagination>
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import {
  getMytasks,
  finishtask,
  updateST,
  getTasksbyid,
  getNotes,
  addNote,
  getAdmin,
  deleteNote,
  updateTask,
} from "../../api/myTask";
import { login, login1 } from "../../api/userMG";
import { getstatuss } from "../../api/setting";

export default {
  data() {
    return {
      src: localStorage.getItem("qrcode"),
      //获取每个弹窗的开始时间
      idTime: "",
      //禁用当前时间之前的时间
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.idTime + " 00:00:00").getTime(); // 选当前时间之前的时间
        },
      },
      user: localStorage.getItem("userId"),
      activeName: "first",
      gongzhong: false,
      //表格数据
      tableData: [
        { id: 1, name: "23", num: 1, name2: "saf", se: "sewq" },
        { id: 1, name: "23", num: 1, name2: "saf", se: "sewq" },
        { id: 1, name: "23", num: 1, name2: "saf", se: "sewq" },
        { id: 1, name: "23", num: 1, name2: "saf", se: "sewq" },
        { id: 1, name: "23", num: 1, name2: "saf", se: "sewq" },
      ],
      //我收到的任务列表
      mytask: [],
      //我收到的任务数量
      mytask_count: "",
      //今日要做
      tasking: [],
      //今日要做数量
      tasking_count: "",
      //任务已完成列表
      myFinishTask: [],
      //单个任务详情数据
      mytaskbyid: {},
      mytaskbyidTask: {},
      avatar: {
        avatar1: "",
      },
      //笔记列表
      notes: [],
      //新增笔记数据
      addnote1: "",
      //表单数据
      formInline: {
        status: "",
      },
      //分页数据
      currentPage: 1,
      total: 1,
      limit: 10,
      //状态下拉数据
      typeList: [],
      //详情遮罩层
      editFormVisible: false,
      //二维码遮罩层
      editFormVisible1: false,
      title1: "请绑定微信二维码",
      title: "任务名称",
      //优先级
      xuanze: [
        {
          value: "2",
          label: "加急",
        },
        {
          value: "3",
          label: "最高",
        },
        {
          value: "4",
          label: "较高",
        },
        {
          value: "1",
          label: "普通",
        },
      ],
      // 状态
      imStatus: "",
      // 优先级
      priority: "",
      //添加参与人
      admin: [],
      value: "",
      //状态是否小于3
      thStatus: 1,
      //计数器
      timer: "",
      numb: 0,
      table1: "",
      ruleForm: {
        //username和password默认为空
        username: localStorage.getItem("username"),
        password: localStorage.getItem("pd"),
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //获取每一行的颜色
    getColor(item) {
      if (item.status < 3) {
        this.thStatus = 2;
      } else {
        for (let type1 in this.typeList) {
          if (item.status == this.typeList[type1].id) {
            return this.typeList[type1].color.toString();
          }
        }
      }
    },
    //获取状态列表
    getstatu() {
      let params = {
        token: localStorage.getItem("token"),
        page: this.currentPage,
      };
      getstatuss(params).then((res) => {
        if (res.errno === 0) {
          this.typeList = res.data.data;
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.errno);
        }
      });
    },

    //转换时间格式
    dateFormat(fmt, date) {
      let ret = "";
      date = new Date(date);
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    //添加笔记
    addnote() {
      let params = {
        token: localStorage.getItem("token"),
        content: this.addnote1,
      };
      addNote(params).then((res) => {
        if (res.errno === 0) {
          this.$message({
            message: "笔记添加成功",
            type: "success",
          });
          this.addnote1 = "";
          this.getNotes1();
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.data);
        }
      });
    },
    //删除笔记
    delnote(id) {
      this.$confirm("确定要删除该笔记吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          token: localStorage.getItem("token"),
          id: id,
        };
        deleteNote(params).then((res) => {
          if (res.errno === 0) {
            this.$message({
              message: "笔记删除成功",
              type: "success",
            });
            this.getNotes1();
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.data);
          }
        });
      });
    },
    //获取笔记列表
    getNotes1() {
      let params = {
        token: localStorage.getItem("token"),
      };
      getNotes(params).then((res) => {
        if (res.errno === 0) {
          this.notes = res.data.data;
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //修改时间
    updateTime(id, project_id) {
      let params = {
        token: localStorage.getItem("token"),
        id: id,
        project_id: project_id,
        end_time: this.dateFormat("YYYY-mm-dd", this.mytaskbyid.end_time),
      };
      if (
        new Date(this.mytaskbyid.end_time.toString().replace(/-/g, "/")) >=
        new Date(this.mytaskbyid.start_time.toString().replace(/-/g, "/"))
      ) {
        updateTask(params).then((res) => {
          if (res.errno === 0) {
            this.$message({
              message: "时间修改成功",
              type: "success",
            });
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.data);
          }
        });
      } else {
        this.$message({
          message: "结束时间不得小于开始时间",
          type: "error",
        });
      }
    },

    //修改优先级
    updateTa(id, project_id) {
      let params = {
        token: localStorage.getItem("token"),
        id: id,
        project_id: project_id,
        priority: this.priority,
      };
      updateTask(params).then((res) => {
        if (res.errno === 0) {
          this.$message({
            message: "优先等级修改成功",
            type: "success",
          });
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.data);
        }
      });
    },
    //打开详情-获取单个任务
    open(id) {
      this.editFormVisible = true;
      let params = {
        token: localStorage.getItem("token"),
        id: id,
      };
      getTasksbyid(params).then((res) => {
        if (res.errno === 0) {
          this.mytaskbyid = res.data;
          this.avatar.avatar1 = res.data.charger_avatar;
          this.idTime = res.data.start_time;
          this.mytaskbyidTask = res.data.taskuser;
          this.priority =
            res.data.priority == 1
              ? "普通"
              : res.data.priority == 2
                ? "加急"
                : res.data.priority == 3
                  ? "最高"
                  : "较高";
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取我的任务活动任务列表
    getTaskData() {
      let params = {
        token: localStorage.getItem("token"),
      };
      getMytasks(params).then((res) => {
        if (res.errno === 0) {
          this.mytask = res.data.mytask;
          this.mytask_count = res.data.mytask_count;
          this.tasking_count = res.data.tasking_count;
          this.tasking = res.data.tasking;
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取我的任务已完成列表
    getFinishTask() {
      let params = {
        token: localStorage.getItem("token"),
        page: this.currentPage,
      };
      finishtask(params).then((res) => {
        if (res.errno === 0) {
          this.myFinishTask = res.data.data;
          this.limit = res.data.per_page;
          this.total = res.data.total;
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //修改备注
    updateMark(id, project_id) {
      let params = {
        token: localStorage.getItem("token"),
        id: id,
        project_id: project_id,
        remark: this.mytaskbyid.remark
      };
      updateTask(params).then((res) => {
        if (res.errno === 0) {
          this.getTaskData();
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.editFormVisible = false;
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //编辑状态
    updateStatus(val, id) {
      let params = {
        token: localStorage.getItem("token"),
        id: id,
        status: val,
      };
      updateST(params).then((res) => {
        if (res.errno === 0) {
          this.getTaskData();
          this.$message({
            message: "状态修改成功",
            type: "success",
          });
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },

    handkeClick(tab, event) {
      this.getFinishTask();
    },
    //分页方法
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getFinishTask();
    },
    //表单提交
    onSubmit() {
      // console.log('submit!');
    },
    errorHandler() {
      return true;
    },
    errorHandler1() {
      return true;
    },
    openqrcode() {
      if (localStorage.getItem("stateid") == 1) {
        if (localStorage.getItem("openid") == "null") {
          this.editFormVisible1 = true;

        }
      }
    },
    openimg() {
      if (this.gongzhong == true) {
        this.gongzhong = false
      } else {
        this.gongzhong = true
      }
    },

  },


  mounted() {
    this.getTaskData();
    this.getFinishTask();
    this.getNotes1();
    this.getstatu();
    this.openqrcode();
    const timer = setInterval(() => {
      this.numb++;
      if (localStorage.getItem("openid") == "null") {
        if (localStorage.getItem("stateid") == 1) {
          if (this.editFormVisible1 == false) {
            localStorage.setItem("stateid", 2);
            clearInterval(timer);
          } else {
            login1(this.ruleForm).then((res) => {
              this.table1 = res.data.user.openid;
              // if (this.numb == 7) {
              //   clearInterval(timer);
              //   this.editFormVisible1 = false;
              //   this.$message({
              //     type: "warning",
              //     message: "微信绑定超时",
              //   });
              //   localStorage.setItem("stateid", 2);
              // } else
              if (this.table1 != null) {
                this.editFormVisible1 = false;
                this.$message({
                  message: "微信绑定成功",
                  type: "success",
                });
              }
            });
          }
        } else {
          clearInterval(timer);
        }
      } else {
        clearInterval(timer);
      }
    }, 2000);

    // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
    this.$once("hook:beforeDestroy", () => {
      clearInterval(timer);
    });
  },
};
</script>

<style scoped>
[v-cloak] {
  display: none;
}

/*活动任务样式 */

/*  table栏切换开始 */
.god {
  height: 100%;
  background-color: #fbfbfb;
}

.q-pa-sm {
  background-color: #fbfbfb;
}

.q-pa-sm>>>.el-tabs__header {
  padding-left: 30px;
  background-color: #ffffff;
}

.q-pa-sm>>>.el-tabs__nav-wrap::after {
  content: "";
  background-color: revert;
}

.q-pa-sm>>>.el-tabs__nav {
  height: 60px;
}

.q-pa-sm>>>.el-tabs__item.is-active {
  color: #141464;
  font-size: 17px;
  font-weight: 700;
}

.q-pa-sm>>>.el-tabs__item {
  color: #666666;
}

.q-pa-sm>>>.el-tabs__active-bar {
  background-color: #2b52e9;
}

.q-pa-sm>>>.el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 0;
  height: 60px;
  line-height: 60px;
}

.q-pa-sm>>>.el-tabs__item {
  font-size: 16px;
}

/*间距*/
.q-pa-sm>>>.el-row {
  margin-top: 25px;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

/*  table栏切换结束 */

/* 活动任务开始 */
.col-title {
  font-weight: 700;
  color: #141464;
  font-size: 20px;
  margin-left: 30px;
  margin-bottom: 12px;
}

.col-title span {
  color: #ff606d;
}

.el-col {
  border-radius: 4px;
}

.bg-purple {
  padding: 25px 30px;
  background-color: #ffffff;
  border-radius: 10px;
}

.bg-purple-light {
  background: #e5e9f2;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

/* 活动任务 -> 小格子 */
.grid-content {
  min-height: 900px;
}

/* 选择   未开始*/

.min-box {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  min-height: 160px;
  border-radius: 10px;
  background-color: #f2edfc;
  padding: 20px;
  margin-bottom: 20px;
  overflow: hidden;
}

.min-box-active {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  min-height: 160px;
  border-radius: 10px;
  background-color: #f2edfc;
  padding: 20px;
  margin-bottom: 20px;
  overflow: hidden;
}

.min-box-active .wangle>>>input {
  color: #7747df;
  text-overflow: ellipsis;
}

.min-box-active>>>.el-icon-sanjiaoxing-copy {
  color: #7747df;
}

.min-box .wangle>>>input {
  color: #141464;
  text-overflow: ellipsis;
}

.wangle>>>.el-input__inner {
  width: 75px !important;
  height: 21px !important;
}

.min-header {
  height: 30px;
  display: flex;
  justify-content: space-between;
}

.conduct {
  height: 30px;
  padding: 0 20px;
  line-height: 30px;
  background-color: #8c939d;
}

.min-img {
  margin-top: 20px;
}

.min-img>>>.el-avatar>img {
  display: inline-block;
}

.font-icon>>>.el-avatar>img {
  display: inline-block;
}

.lefta>>>.el-avatar>img {
  display: inline-block;
}

.min-name {
  height: auto;
  margin: 15px 0;
  width: auto;
  margin-right: 40px;
  max-width: 370px;
  font-size: 22px;
  color: #333333;
  word-wrap: break-word;
  word-break: break-all;
}

.min-data {
  display: flex;
  justify-content: space-between;
  height: 30px;
  width: 100%;
}

.min-data span {
  width: 95%;
  overflow: hidden;
  color: #ffffff;
  font-size: 16px;
  line-height: 30px;
}

.min-box-active .min-data span:nth-child(1) {
  color: #7747df;
}

.min-box .min-data span:nth-child(1) {
  color: #141464;
}

.min-box>>>.el-icon-sanjiaoxing-copy {
  color: #ffffff;
}

.min-data span:nth-child(2) {
  color: #141464;
}

/*未开始结束*/
/*进行中开始*/
.min-box-start {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  min-height: 160px;
  border-radius: 10px;
  background-color: #ebf9fc;
  padding: 20px;
  margin-bottom: 20px;
  overflow: hidden;
}

.min-box-start .min-data span:nth-child(1) {
  color: #50c4d9;
}

.min-box-start .wangle>>>input {
  color: #50c4d9;
}

.min-box-start>>>.el-icon-sanjiaoxing-copy {
  color: #50c4d9;
}

/*进行中结束*/
/*笔记开始*/
.min-box-book {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  min-height: 160px;
  border-radius: 10px;
  background-color: #f5f8ff;
  padding: 20px;
  margin-bottom: 20px;
  overflow: hidden;
}

.min-box-book .min-name {
  height: auto;
  min-height: 80px;
  margin: 15px 0;
  font-size: 16px;
  color: #333333;
}

.min-box-book .min-data span {
  color: #708aeb;
}

.min-form {
  padding: 14px 12px;
  min-height: 80px;
  margin: 0 auto;
}

.min-form .el-form-item {
  height: 80px;
  margin-bottom: 0;
}

.min-form>>>.el-input__inner {
  height: 60px;
  margin: 10px 0;
  /*width: 315px !important;*/
  border: 1px solid #708aeb;
  background-color: #f5f8ff;
}

.min-form>>>.el-button--primary {
  width: 111px;

  height: 60px;
  margin: 10px 0;
  background-color: #708aeb;
}

.min-form>>>.el-form-item__content {
  width: 100%;
}

.min-form .el-form-item:nth-child(1) {
  width: 70% !important;
}

.min-form .el-form-item:nth-child(2) {
  margin-right: 0;
}

.min-form .el-input__inner::placeholder {
  color: #999999;
}

.min-form .el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers 适配谷歌 */
  color: #999999;
}

.min-form .el-input__inner::-moz-placeholder {
  /* Mozilla Firefox 19+ 适配火狐 */
  color: #999999;
}

.min-form .el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10+  适配ie*/
  color: #999999;
}

/*笔记结束*/

/* 活动任务结束 */

/* 弹出层 */
.q-pa-sm>>>.el-dialog {
  width: 50%;
  /*min-height: 400px;*/
}

.minFont {
  color: #888888;
  font-size: 14px;
}

.minFont1 {
  color: #333333;
  font-size: 16px;
  width: 75px !important;
  height: 30px;
  line-height: 30px;
}

.el-dialog__header {
  padding: 45px 20px 10px;
}

.form-text {
  display: flex;
  position: relative;
  justify-content: space-between;
  flex-wrap: wrap;
  text-decoration: none;
  margin: 0 50px;
}

.edit-dialog>>>.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 10px;
  width: 46%;
  vertical-align: top;
}

.q-pa-sm>>>.el-dialog__title {
  font-size: 20px;
  color: #141464;
  font-weight: 700;
}

.q-pa-sm>>>.el-dialog__headerbtn {
  top: 3px;
  right: 3px;
  font-size: 25px;
}

.edit-dialog>>>.el-input.is-disabled,
.edit-dialog>>>.el-input__inner {
  width: 100%;
  height: 32px;
  background-color: #ffffff;
  border-color: #cccccc;
  color: #666666;
  border-radius: unset;
  cursor: not-allowed;
}

.edit-dialog>>>.el-select .el-input__inner {
  cursor: pointer;
}

.edit-dialog>>>.el-textarea__inner {
  /*width: 330px;*/
  background-color: #ffffff;
  border-color: #cccccc;
  color: #666666;
  border-radius: unset;
  cursor: not-allowed;
}

.lefta {
  margin-left: 13px;
}

.lefta>>>.el-form-item__content {
  max-width: 260px;
}

.beijinyuan {
  position: relative;
  width: 49px;
  height: 49px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  background-color: #f2f6ff;
}

.beijinyuan>>>i {
  position: relative;
  left: 8px;
  top: 2px;
  color: #2b51e8;
}

/*.leftb{*/
/*  position: absolute;*/
/*  top: 62px;*/
/*  left: 12px;*/
/*}*/

.dialog-data1 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 50px;
}

.dialog-data2 {
  display: flex;
  flex-wrap: wrap;
  margin-right: 10px;
  margin-bottom: 10px;
}

.font-icon {
  font-size: 34px !important;
  margin-right: 10px;
}

.min-data i {
  font-size: 17px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 160px;
  color: #ff606d;
  cursor: pointer !important;
}

.dialog-data2>>>.el-input__inner {
  border: none;
  padding: 0;
  width: 120px;
  color: #333333;
  font-size: 16px;
  height: 21px;
  color: #ff606d;
  cursor: pointer !important;
}

.lastitem>>>.el-form-item__content {
  width: 85%;
}

.dialog-data2>>>.el-select span,
.dialog-data2>>>.el-date-editor span {
  display: none;
}

.el-table {
  margin-top: 35px;
}

.wangle>>>input {
  border: none !important;
  padding: 0 !important;
  width: 80px;
  border-radius: unset;
  background: none;
  font-size: 16px;
}

.wangle>>>span {
  display: none;
}

.wangle>>>.el-icon-arrow-up:before {
  content: '';
}

.q-pa-sm>>>.el-form-item__label {
  padding: 0 14px 0 0;
}

body>>>.el-select-dropdown .el-popper {
  top: 275px !important;
  left: 290px !important;
}

.eldiang>>>.el-dialog {
  width: 25%;
}

.eldiang>>>.el-dialog__body {
  text-align: center;
}

/*
  *
  *
  *2021.5.7 新增修改
  *
  */
.wangle>>>.el-input {
  height: 30px;
  line-height: 30px;
}

.lastitem>>>.el-textarea__inner {
  cursor: pointer;
}

/* 确定按钮 */

.el-button.btn-submit {
  background: #2b52e9;
  border-color: #2b52e9;
  color: #fff;
  width: 80px;
  height: 32px;
}

.el-button.btn-submit1 {
  background: #ebf2fc;
  border-color: #2b52e9;
  color: #2b52e9;
  width: 160px;
  height: 32px;
}

.wcrw {
  width: 100% !important;
}

.heihei>>>.el-input__inner {
  width: 55px;
}

.wangle {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 20;
}
</style>



// WEBPACK FOOTER //
// src/views/work/myTask.vue